import useSWR from "swr";
import axios from "lib/axios";
import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import {
  clearStorage,
  getStorage,
  handleget_headers_params,
  saveStorage,
  showToastr,
  redirect,
} from "pages/Utils";
import { usePathname, useRouter } from "components/Navigation";

export const useAuth = ({
  middleware,
  redirectIfAuthenticated,
  onRequestDone,
} = {}) => {
  let navigate = useNavigate();
  let params = useParams();
  const router = useRouter();

  // const {
  //   data: user,
  //   error,
  //   mutate,
  // } = useSWR(
  //   "/api/user",
  //   () =>
  //     axios(handleget_headers_params(true))
  //       .get("/api/user")
  //       .then((res) => res.data)
  //       .catch((error) => {
  //         if (error.response.status !== 409) throw error;

  //         mutate("/verify-email");
  //       }),
  //   {
  //     revalidateIfStale: false,
  //     revalidateOnFocus: false,
  //   }
  // );

  function getAppKey() {
    const path = window.location.pathname;
    if (path.startsWith("/user")) return "user";
    if (path.startsWith("/audit")) return "audit";
    return "manrisk";
  }

  const mutate = async () => {
    const user_loginObj = getStorage("user_login");

    // console.log('MUTATE==>');
    // console.log('user_loginObj');
    // console.log(user_loginObj);
    const appKey = getAppKey();

    if (user_loginObj) {
      const user_login = JSON.parse(user_loginObj);
      if (user_login.user && user_login.user.id_user) {
        // navigate(redirectIfAuthenticated);

        let path = "/dashboard";
        // const urlsaved = sessionStorage.getItem("urlsaved");
        const urlsaved = sessionStorage.getItem(`urlsaved_${appKey}`);
        if (urlsaved) {
          path = urlsaved;
        }

        if (user_login.groups) {
          path = "/akses";
        }
        // window.location.href = path;
        redirect(path);
      }
    } else {
      // sessionStorage.setItem("urlsaved", "");
      sessionStorage.setItem(`urlsaved_${appKey}`, "");

      // window.location.href = "/login";
      redirect("/login");
    }
  };

  const csrf = () =>
    axios(handleget_headers_params(true)).get("/sanctum/csrf-cookie");

  const register = async ({ setErrors, ...props }) => {
    await csrf();
    setErrors([]);
    axios(handleget_headers_params(true))
      .post("/register", props)
      .then(() => mutate())
      .catch((error) => {
        if (error.response.status !== 422) throw error;
        setErrors(Object.values(error.response.data.errors).flat());
      });
  };

  const [responDataLogin, setResponDataLogin] = useState();
  const login = async ({ setErrors, setStatus, ...props }) => {
    await csrf();
    setErrors([]);
    setStatus(null);
    axios(handleget_headers_params(true))
      .post("/login", props)
      .then(async (res) => {
        console.log(res);
        if (res.data.groups) {
          setResponDataLogin(res.data);
        } else {
          await handleSaveStorage("isLoggedIn", "1");
          await handleSaveStorage("is_arr_group", "0");
        }
        await handleSaveStorage("user_login", res.data);
        return mutate();
      })
      .catch((error) => {
        // console.log('error')
        // console.log(error)
        if (error.response.status !== 422) throw error;
        if (
          error.response.data &&
          error.response.data.messages &&
          error.response.data.messages.errors
        ) {
          showToastr("error", error.response.data.messages.errors);
        }
        setErrors(Object.values(error.response.data.errors).flat());
        if (onRequestDone) {
          onRequestDone();
        }
      });
  };
  const get_me = async () => {
    // await csrf();
    // setErrors([]);
    // setStatus(null);
    axios(handleget_headers_params(true))
      .get("/me")
      .then(async (res) => {
        console.log(res);
        if (res.data.groups) {
          setResponDataLogin(res.data);
        } else {
          await handleSaveStorage("isLoggedIn", "1");
          await handleSaveStorage("is_arr_group", "0");
        }
        await handleSaveStorage("user_login", res.data);
        return mutate();
      })
      .catch((error) => {
        // console.log('error')
        // console.log(error)
        if (error.response.status !== 422) throw error;
        if (
          error.response.data &&
          error.response.data.messages &&
          error.response.data.messages.errors
        ) {
          showToastr("error", error.response.data.messages.errors);
        }
        setErrors(Object.values(error.response.data.errors).flat());
        if (onRequestDone) {
          onRequestDone();
        }
      });
  };

  const login_session = async ({ setErrors, setStatus, ...props }) => {
    await csrf();

    setErrors([]);
    setStatus(null);

    axios(handleget_headers_params(true))
      .get("api/get_session", props)
      .then(async (res) => {
        if (res) {
          await handleSaveStorage("user_login", res.data);
        }

        await save_default_filter(res);

        // if (res.data && res.data.groups && props.onshow_groups) {
        //   return props.onshow_groups();
        // }
        console.log("res.data");
        console.log(res.data);
        if (res.data) {
          await handleSaveStorage("isLoggedIn", "1");
          showToastr("success", "Login berhasil!");

          return mutate();
        }
      })
      .catch((error) => {
        console.log("error nich");
        console.log(error);
        if (error.response && error.response.status !== 422) throw error;
        if (
          error.response &&
          error.response.data &&
          error.response.data.error &&
          error.response.data.messages.errors
        ) {
          showToastr(
            "error",
            `Login gagal! ${error.response.data.messages.errors}`
          );
        }
        if (error.response && error.response.data) {
          setErrors(error.response.data.errors);
        }
      });
  };

  const forgotPassword = async ({ setErrors, setStatus, email }) => {
    await csrf();
    setErrors([]);
    setStatus(null);
    axios(handleget_headers_params(true))
      .post("/forgot-password", { email })
      .then((response) => setStatus(response.data.status))
      .catch((error) => {
        if (error.response.status !== 422) throw error;
        setErrors(Object.values(error.response.data.errors).flat());
      });
  };

  const resetPassword = async ({ setErrors, setStatus, ...props }) => {
    await csrf();
    setErrors([]);
    setStatus(null);
    axios(handleget_headers_params(true))
      .post("/reset-password", { token: params.token, ...props })
      .then((response) =>
        navigate(`/login?reset=${btoa(response.data.status)}`)
      )
      .catch((error) => {
        if (error.response.status !== 422) throw error;
        setErrors(Object.values(error.response.data.errors).flat());
      });
  };

  const resendEmailVerification = ({ setStatus }) => {
    axios(handleget_headers_params(true))
      .post("/email/verification-notification")
      .then((response) => setStatus(response.data.status));
  };

  const logout = async () => {
    // console("tesss logout", error);
    // if (!error) {
    await axios(handleget_headers_params(true))
      .post("/logout")
      .then(() => mutate());
    await clearStorage();
    // }
    window.location.pathname = "/login";
  };

  const handleSaveStorage = async (key, data) => {
    await saveStorage(key, JSON.stringify(data));
  };

  // useEffect(() => {
  //   console.log("redirectIfAuthenticated", redirectIfAuthenticated);
  //   console.log("middleware", middleware);
  //   console.log("user", user);
  //   if (middleware === "guest" && redirectIfAuthenticated && user) {
  //     console.log("redirectIfAuthenticated", redirectIfAuthenticated);
  //     console.log("middleware", middleware);
  //     console.log("user", user);
  //     if (responDataLogin) {
  //       router.push("/akses");
  //     } else {
  //       navigate(redirectIfAuthenticated);
  //     }
  //   }
  //   if (middleware === "auth" && error) logout();
  // }, [user, error]);

  const save_default_filter = async (res) => {
    const filter = {
      dashboard: {
        jenis_progress_efektivitas: "progres",
      },
      csa: {
        tlc: {},
        elc: {},
        itgc: {},
      },
      tod: {
        tlc: {},
        elc: {},
        itgc: {},
      },
      toe: {
        tlc: {},
        elc: {},
        itgc: {},
      },
      perubahan_kuesioner: {
        tlc: {},
        elc: {},
        itgc: {},
      },
      remediasi: {
        tlc: {},
        elc: {},
        itgc: {},
      },
      kuesioner: {
        tlc: {},
        elc: {},
        itgc: {},
      },
      tod_edit: {
        tlc: {},
        elc: {},
        itgc: {},
      },
      dod: {
        tlc: {},
        elc: {},
        itgc: {},
      },
    };

    if (res && res.data && res.data.id_group == 2) {
      filter.toe.tlc.id_status = "12";
      filter.toe.elc.id_status = "12";
      filter.toe.itgc.id_status = "12";
    }
    return await handleSaveStorage("filter", filter);
  };
  const change_app = async ({ setErrors, setStatus, ...props }) => {
    try {
      // const res = await axios().post("/change_app", props);
      const res = await axios().get("/generate-switch-token", props);

      return res.data;
    } catch (error) {
      if (error.response && error.response.status !== 422) throw error;
      if (
        error.response?.data?.error &&
        error.response?.data?.messages?.errors
      ) {
        showToastr(
          "error",
          `Login gagal! ${error.response.data.messages.errors}`
        );
      }
      if (setErrors) setErrors(error.response.data.errors);
      return null;
    }
  };
  return {
    // user,
    register,
    login,
    forgotPassword,
    resetPassword,
    resendEmailVerification,
    logout,
    login_session,
    save_default_filter,
    change_app,
    get_me,
  };
};
